import styled from 'styled-components';

const Root = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  user-select: none;
  &:hover {
    background-color: var(--tonal);
  }
  &:active {
    background-color: var(--tonal-deep);
  }
  &:hover,
  &:active {
    .material-symbols-rounded {
      color: var(--text-secondary);
    }
  }
  .material-symbols-rounded {
    font-size: 1.25rem;
    font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    color: var(--text-tertiary);
  }
  &.small {
    height: 1.75rem;
    width: 1.75rem;
    .material-symbols-rounded {
      font-size: 1.125rem;
    }
  }
  &.large {
    border-radius: 0.25rem;
    .material-symbols-rounded {
      font-size: 1.5rem;
    }
  }
  &.tonal {
    /* background-color: var(--tonal); */
    .material-symbols-rounded {
      color: var(--text-disabled);
    }
    &:hover {
      background-color: var(--tonal-deep);
      .material-symbols-rounded {
        color: var(--text-tertiary);
      }
    }
  }
  &.blue {
    background-color: var(--tonal-blue);
    .material-symbols-rounded {
      color: var(--primary);
    }
    &:hover {
      background-color: var(--tonal-deep-blue);
    }
  }
  &.red {
    background-color: var(--tonal-red);
    .material-symbols-rounded {
      color: var(--filled-red);
    }
    &:hover {
      background-color: var(--tonal-red);
    }
  }
`;

type Props = {
  icon: string;
  onClick: () => void;
  size?: 'large' | 'small';
  color?: 'blue' | 'red' | 'tonal';
};

const SmallIconButton = ({ icon, onClick, size, color }: Props) => {
  const style = () => {
    return ` ${size ?? ''} ${color ?? ''}`;
  };
  return (
    <Root role='button' tabIndex={0} onClick={onClick} className={style()}>
      <span className='material-symbols-rounded'>{icon}</span>
    </Root>
  );
};

export default SmallIconButton;
